import React, { forwardRef, useRef } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { Tooltip } from 'antd';
import { modes } from '../../constants/modes';
import { setLocalTask } from '../../store/actions/calendarActions';
import {
  useCalendarDispatch,
  useCalendarRequestInteractions,
  useCalendarState,
} from '../../context/CalendarContext';
import TooltipContent from './components/TooltipContent/TooltipContent';
import { formatPhoneNumber } from '../../../../helpers/formatPhoneNumber';
import styles from './Task.module.scss';
import { views } from '../../constants/views';

const getTooltipText = (task) => {
  const requestId = task.requestId || '';
  const workerSurName = task.worker.surName || '';
  const fromDate = moment(task.fromDate).format('HH:mm') || '';
  const toDate = moment(task.toDate).format('HH:mm') || '';
  const fullAddress = task.fullAddress || '';

  return {
    tooltipText: (
      <TooltipContent
        requestId={requestId}
        workerName={workerSurName}
        interval={`${fromDate} - ${toDate}`}
        address={fullAddress}
      />
    ),
    interval: `${fromDate} - ${toDate}`,
  };
};

const tooltipAlign = {
  overflow: {
    alwaysByViewport: true,
    adjustX: true,
    adjustY: true,
  },
};

const Task = forwardRef(
  (
    {
      infoDirection = 'row',
      hideWorkers = false,
      hideTimeInterval = false,
      inline = false,
      rootClassName,
      task = {},
      isModal = false,
      style = {},
      tooltipPlacement = 'bottom',
      withShadow = false,
      getPopupContainer = () => document.body,
      withPopover = false,
      onTaskClick,
      ...props
    },
    ref
  ) => {
    const dispatch = useCalendarDispatch();
    const { mode, localTask, showOwner, view } = useCalendarState();
    const { onTaskOpen } = useCalendarRequestInteractions();

    const handleClick = (e) => {
      e.stopPropagation();

      if (localTask) {
        dispatch(setLocalTask(null));
      }

      const handleTaskOpen = onTaskClick || onTaskOpen;

      if (typeof handleTaskOpen === 'function') {
        handleTaskOpen(task);
      }
    };

    const { tooltipText, interval } = getTooltipText(task);

    return (
      <Tooltip
        overlayClassName={styles.tooltip}
        title={isModal || mode === modes.agenda ? '' : tooltipText}
        placement={tooltipPlacement}
        getPopupContainer={getPopupContainer}
        align={tooltipAlign}
      >
        <div
          onClick={!withPopover ? handleClick : undefined}
          {...props}
          className={cn(styles.root, rootClassName, {
            [styles.inline]: inline,
            [styles.shadow]: withShadow,
          })}
          style={style}
          ref={ref}
        >
         {/* <div className={(Math.abs(new Date(task.toDate) - new Date(task.fromDate)) / 36e5 === 1 && showOwner && mode === modes.calendar && view === views.day) ? styles.centerBlock : ''}> */}
          <div className={cn(styles.infoContainer, styles[infoDirection])}>
            <p className={cn(styles.content, styles.number)}>
              {task.requestId || ''}
            </p>
            {!hideTimeInterval && <p className={styles.content}>{interval}</p>}
          </div>
          {!hideWorkers && (
            task.addressSynonym && view === views.day ? (
              <p className={cn(styles.content, styles.workers)} style={{wordWrap: 'break-word', whiteSpace: 'normal', textOverflow: 'unset'}}>
              {`${task.fullAddress} (${task.addressSynonym})` || ''}
            </p>
            ) : (
              <p className={cn(styles.content, styles.workers)}>
              {task.fullAddress || ''}
            </p>
            )
          )}
          {showOwner && (mode === modes.agenda || (mode === modes.calendar && (view === views.day)  && Math.abs(new Date(task.toDate) - new Date(task.fromDate)) / 36e5 >= 1)) ? (
            <p className={cn(styles.ownerWrap)}>
              <span className={cn(styles.content, styles.workers)}>
                {task.clientName || 'Не указано'}
              </span>
              {task.clientPhones
                ? task.clientPhones.split(', ').map((phone) => (
                    <span
                      className={cn(styles.content, styles.workers)}
                      key={phone}
                    >
                      {formatPhoneNumber({
                        phoneNumber: phone,
                        format: '(xxx) xxx-xx-xx',
                        placeholder: 'x',
                      })}
                    </span>
                  ))
                : null}
            </p>
          ) : null}
          {/* </div> */}
        </div>
      </Tooltip>
    );
  }
);

export default Task;
